import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { LocationCardComponent } from '@app/main/main-content/location/components/location-card/location-card.component';
import { DialogEventState } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-state.service';
import { DialogEventTabsService } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-tabs.service';
import { DialogEventEditor } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-editor.enum';

@Component({
  selector: 'gc-dialog-event-location-card',
  standalone: true,
  imports: [LocationCardComponent],
  templateUrl: './dialog-event-location-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class DialogEventLocationCardComponent {
  private readonly dialogState = inject(DialogEventState);
  private readonly tabs = inject(DialogEventTabsService);

  protected readonly draft = this.dialogState.draft;

  public showShare = input<boolean>(true);

  protected editLocation(): void {
    this.tabs.openEditor(DialogEventEditor.Location);
  }
}
